import { isQueryStatementCompleted } from "pages/DevelopWorkspace/contexts/DocumentsContext/helpers/getQueryStatementState";
import {
  DocumentsState,
  QueryStatement,
  QueryStatementStatus,
  WorkspaceDocument,
} from "pages/DevelopWorkspace/workspace.types";

const getStatusToPersist = (
  context: WorkspaceDocument["context"],
  queryStatement: QueryStatement
) => {
  if (isQueryStatementCompleted(queryStatement)) {
    return queryStatement.status;
  }

  if (queryStatement.status === QueryStatementStatus.pending) {
    return QueryStatementStatus.pending;
  }

  if (
    queryStatement.status === QueryStatementStatus.running &&
    context.engine.name !== "system"
  ) {
    return QueryStatementStatus.unknown;
  }
  return QueryStatementStatus.cancelled;
};

const persistFilter = (state: DocumentsState) => {
  const nextDocuments = state.documents.map(document => {
    if (!document.execution) {
      return document;
    }

    return {
      ...document,
      aiState: null,
      execution: {
        ...document.execution,
        cancellationStatus: undefined, // reset cancellation status
        queryStatements: document.execution.queryStatements.map(
          queryStatement => {
            const status = getStatusToPersist(document.context, queryStatement);

            return {
              ...queryStatement,
              status,
              error: null,
            };
          }
        ),
      },
    };
  });

  return {
    ...state,
    documents: nextDocuments,
  };
};
export { persistFilter };
